export default async function (errors: Array<String>) {
    const firstError = Object.keys(errors)[0];
    const el = document.querySelector<HTMLInputElement>(`[name="${firstError}"]`);
    el?.scrollIntoView({
        behavior: "smooth",
    });
    el.focus();
}
